// extracted by mini-css-extract-plugin
export default {"Container":"AddVariableModal_Container__lKBtF","SelectDropdown":"AddVariableModal_SelectDropdown__FqzEx","Footer":"AddVariableModal_Footer__VNG5Q"};